var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 50,
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7816 25.4644C30.4743 27.7351 31.506 30.4297 31.7627 33.2502C32.0195 36.0707 31.4912 38.9073 30.2364 41.4464C28.9816 43.9854 27.0491 46.128 24.6525 47.6372C22.256 49.1465 19.4888 49.9636 16.6568 49.9983C13.8248 50.0329 11.0384 49.2837 8.60566 47.8336C6.1729 46.3834 4.18854 44.2888 2.87198 41.7812C1.55541 39.2736 0.957921 36.4508 1.14556 33.6249C1.33321 30.7989 2.29868 28.0799 3.93523 25.7684L8.94869 29.318C7.96676 30.7049 7.38748 32.3363 7.27489 34.0319C7.1623 35.7274 7.5208 37.4211 8.31074 38.9257C9.10068 40.4302 10.2913 41.687 11.7509 42.5571C13.2106 43.4272 14.8824 43.8767 16.5816 43.8559C18.2808 43.8351 19.9411 43.3448 21.3791 42.4393C22.817 41.5337 23.9765 40.2482 24.7294 38.7248C25.4823 37.2013 25.7992 35.4994 25.6452 33.8071C25.4911 32.1148 24.8721 30.498 23.8565 29.1355L28.7816 25.4644Z",
    fill: "#6AD699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79053 21.3436C11.1942 19.9558 13.929 19.2454 16.7041 19.2879C19.4793 19.3304 22.1911 20.1242 24.5511 21.5849L21.3183 26.8082C19.9023 25.9318 18.2752 25.4555 16.6101 25.43C14.945 25.4045 13.3041 25.8308 11.8619 26.6634L8.79053 21.3436Z",
    fill: "#6AD699"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20312 13.4248C8.71807 11.1555 12.8204 9.96491 17.0041 9.99977C21.1877 10.0346 25.2697 11.2934 28.7463 13.6209L25.4227 18.5855C22.9154 16.907 19.9715 15.9991 16.9543 15.974C13.9371 15.9489 10.9785 16.8075 8.44356 18.4441L5.20312 13.4248Z",
    fill: "#6AD699"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.615234 4.56765C5.47552 1.42989 11.1738 -0.158531 16.9564 0.0124922C22.7391 0.183515 28.3335 2.10592 32.9999 5.52544L29.3092 10.5618C25.6626 7.88954 21.2908 6.38725 16.7719 6.2536C12.2529 6.11995 7.79992 7.36124 4.00178 9.81329L0.615234 4.56765Z",
    fill: "#6AD699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.a7e059ad2bb72814ca66af4a289278bd.svg";
export { ForwardRef as ReactComponent };